import { object, string, boolean, array } from 'yup';

export const AddUserSchema = object({
  id: string().required(), 
  nom: string().required('Nom Obligatoire!!'),
  prenom: string().required('Prénom Obligatoire!!'),
  email: string().email("Veuillez bien saisir un email valide").required('Email Obligatoire!!'),
  mobile: string().required('Mobile Obligatoire!!'),
 
  organisations: array().of(string()), 
  gender: string().oneOf(['homme', 'femme']).required('Genre Obligatoire!!'),
  role_id: string(), 
 
  horaire: object().shape({
    TimeOn: string().required("Heure d'entrée requise"),
    TimeOut: string().required("Heure de sortie requise"),
  })
});
